module.exports = __webpack_public_path__ + "media/images/static/oiwai/banner-5d76fa1f5263fef67d45149299ff6bb2.png";